import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { Campaign, CampaignStepEnum } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface AddConfirmedStepParams {
  id: string;
  confirmedStep: CampaignStepEnum;
}

export const addConfirmedStep = async (params: AddConfirmedStepParams): Promise<Campaign> => {
  return await tinctApi.campaigns.addConfirmedStep(params.id, params.confirmedStep);
};

export const useAddConfirmedStep = (
  options?: Omit<
    UseMutationOptions<Campaign, ApiError, AddConfirmedStepParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addConfirmedStep,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', args[1].id] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
